<template>
  <div id="prepare-login">
    <div v-if="loading">
      <img
        src="@/assets/loading.gif"
        alt="prepare-login">
    </div>
    <div v-else style=" width: 100%;">
      <div style="text-align: center; margin-bottom: 20px; color: white;">
        <h2>
          เลือกร้านค้า
        </h2>
        <div>
          เลือกร้านค้าเพื่อใช้งานระบบ
        </div>
      </div>
      <div class="card-wrapper">
        <div v-for="store in user.user_store" class="card" :key="store.id" @click="login(store)">
          <div class="store-name">
            <img class="img" :src="store.store.photos[0]" :alt="store.store.name">
            <div style="margin-left: 10px; text-transform: uppercase;">
              {{ store.store.name }}
            </div>
          </div>
          <div class="store-name">
            <div class="btn">
              <span class="btn-text">เชื่อมต่อ</span>
            </div>
          </div>
        </div>
        <div id="no-store" v-if="user.user_store.length === 0">
          <img src="@/assets/sad-meme.png" class="img-no-store" alt="sad">
          <div style="margin-top: 20px; color: white;"> ไม่พบร้านที่ท่านมีสิทธิใช้งาน :( </div>
        </div>
      </div>

      <div class="logout-btn" @click="logout()">
        ออกจากระบบ
      </div>
    </div>
    <div>
    </div>
  </div>
</template>

<script>
import AuthProvider from '@/resources/auth_provider'

const authService = new AuthProvider()
export default {
  data () {
    return {
      loading: true,
      user: {
        user_store: [
        ]
      },
      appList: [
        'inventory://login',
        'inventory-dev://login',
        'inventory-staging://login',
        'gwstore://login',
      ]
    }
  },
  computed: {
    isLoading () {
      return this.$auth.loading
    }
  },
  watch: {
    isLoading (val) {
      if (val === false) {
        this.getStore()
      }
    }
  },
  async mounted () {
    await this.getStore()
  },
  methods: {
    logout () {
      this.$router.push({ name: 'logout' })
    },
    async login (store) {
      const redirectURL = window.localStorage.getItem('callback_uri')
      setTimeout(() => {
        if (this.appList.includes(redirectURL)) {
          const appName = redirectURL.split(':')[0]
          const packageName = appName.split('-').join('.')
          const appUrl = `intent://callback?token_reference=${store.id}#Intent;scheme=${redirectURL};package=com.example.${packageName};end`
          window.location.href = appUrl
        } else {
          window.location.replace(`${redirectURL}?token_reference=${store.id}`)
        }
      }, 300)
    },
    async getStore () {
      try {
        const authStr = window.localStorage.getItem('user')
        const auth0User = authStr ? JSON.parse(authStr) : {}
        const userStore = await authService.getStore({
          email: auth0User.email,
          name: auth0User.name,
          picture: auth0User.picture,
          uid: auth0User.sub
        })
        this.user = userStore.data.data
        this.loading = false
      } catch (err) {
        alert('Unauthorize')
        this.$router.push({ name: 'logout' })
      }
    }
  }
}
</script>

<style scoped>
  #prepare-login {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-image: url('https://gentlewoman-image.imgix.net/cms/editorials/upload/x96141.jpg?fm=webp')
  }
  .card-wrapper {
    background-color: rgba(82, 82, 82, 0.75);
    /* border-radius: 8px; */
    min-width: 300px;
    max-width: 600px;
    margin: auto;
    height: calc(100vh - 300px);
    overflow: auto;
    padding: 50px 20px;
  }
  .card {
    flex-wrap: wrap;
    min-width: 250px;
    max-width: 600px;
    padding: 20px;
    margin: 0px auto 10px auto;
    /* border-radius: 6px; */
    background-color: #fff;
    color: rgba(0,0,0,.87);
    display: flex;
    justify-content: space-between;
  }
  .logout-btn {
    font-size: 14px;
    padding: 4px 30px;
    text-align: center;
    background-color: rgb(255, 60, 60);
    /* background: linear-gradient(90deg, rgb(254, 145, 145) 0%, rgb(255, 60, 60) 100%); */
    width: fit-content;
    margin: auto;
    margin-top: 20px;
    color: #fff;
    /* border-radius: 18px; */
    cursor: pointer;
  }

  @media screen and (max-width: 380px) {
    .card {
      justify-content: center;
    }
    .btn {
      margin-top: 20px;
    }
  }

  .store-name {
    display: flex;
    align-items: center;
  }
  
  .logout {
    text-align: center;
    cursor: pointer;
    width: fit-content;
    margin: 10px auto;
  }
  
  #no-store {
    margin: auto;
    width: fit-content;
    text-align: center;
    color: #1d1d1d;
  }
  .img-no-store {
    width: 180px;
    height: 180px;
    border-radius: 50%;
    border: 1px solid #696969;
  }
  .img {
    width: 60px;
    height: 60px;
    border: 1px solid #1d1d1d;
    padding: 4px;
    /* border-radius: 50%; */
  }
  .btn {
    font-size: 14px;
    padding: 4px 30px;
    text-align: center;
    background-color: #077ffb;
    /* background: linear-gradient(90deg, rgba(148,205,255,1) 0%, rgba(7,127,251,1) 100%); */
    color: #fff;
    /* border-radius: 18px; */
    cursor: pointer;
  }
</style>
